import {FC, useEffect, useRef, useState, ReactNode} from "react"
import {createPortal} from "react-dom"

interface Props {
  children: ReactNode
}

const ModalPortal: FC<Props> = ({children}) => {
  const ref = useRef<Element | null>(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    ref.current = document.querySelector("#modal-root")

    setMounted(true)
  }, [])

  return mounted && ref.current ? createPortal(children, ref.current) : null
}

export default ModalPortal
